import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js"
import axios from "axios"
import React, { useState } from 'react';



const CARD_OPTIONS = {
    iconStyle: "solid",
    style: {
        base: {
            iconColor: "#c4f0ff",
            color: "#fff",
            fontWeight: 500,
            fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
            fontSize: "16px",
            fontSmoothing: "antialiased",
            ":-webkit-autofill": { color: "#fce883" },
            "::placeholder": { color: "#87bbfd" }
        },
        invalid: {
            iconColor: "#ffc7ee",
            color: "#ffc7ee"
        }
    }
}

export default function PaymentForm(props) {
    const [success, setSuccess] = useState(false)
    const stripe = useStripe()
    const elements = useElements()


    const handleSubmit = async (e) => {
        e.preventDefault()
        const { error, paymentMethod } = await stripe.createPaymentMethod({
            type: "card",
            card: elements.getElement(CardElement)
        })


        if (!error) {
            console.log("token", paymentMethod);
            try {
                const { id } = paymentMethod
                const response = await axios.post("https://serverjs.vercel.app/payment", {
                    amount: props.cartTotal,
                    id: id
                })

                console.log(response.data.success);
                if (response.data.success) {
                    console.log("Successful payment")
                    setSuccess(true)


                }


            } catch (error) {
                console.log("Error", error)
            }
        } else {
            console.log(error.message)
        }
    }

    return (
        <>
            {!success ?
                <form onSubmit={handleSubmit}>
                    <fieldset className="FormGroup mx-auto col-lg-5 m">
                        <div className="FormRow">
                            <CardElement options={CARD_OPTIONS} />
                        </div>
                    </fieldset>
                    <div className="col-md-12 text-center">
                        <button className="btn btn-outline-dark text-uppercase  px-5">Pay</button>
                    </div>

                </form>
                :
                <div>

                    <h2 className="text-center">Congrats!!Payment successful</h2>
                </div>
            }

        </>
    )
}